import { ArticleCategory } from '@components/atoms/ArticleCategory/ArticleCategory';
import type { Ressort } from '@lib/graphql/generated';

export interface ArticleOverviewHeaderProps {
  activeItem: Ressort;
  ressorts: Ressort[];
}

export const ArticleOverviewHeader = ({ activeItem, ressorts }: ArticleOverviewHeaderProps) => {
  return (
    <div className="mb-12 grid items-start gap-4 lg:grid-cols-2">
      <div>
        {activeItem?.title && <h1 className="text-gray-600 text-sm uppercase tracking-widest">{activeItem.title}</h1>}
        {activeItem?.subtitle && <div className="font-bold font-herokid text-2xl">{activeItem.subtitle}</div>}
      </div>
      <div className="flex w-full flex-wrap gap-2 rounded-lg bg-white p-2 shadow-card-sm lg:ml-auto lg:w-auto">
        {ressorts?.map((ressort) => {
          return (
            <ArticleCategory
              classProps={{ root: 'shadow-card-sm self-center' }}
              active={ressort.id === activeItem?.id}
              category={ressort}
              isSwitcher
              key={ressort.id}
            />
          );
        })}
      </div>
    </div>
  );
};
